
import { mapMutations } from 'vuex';

export default {
    props: {
        bg: {
            required: false,
        },
        bgOverlay: {
            required: false,
            default: true
        },
        lg: {
            required: false,
            default: false
        },
        xl: {
            required: false,
            default: false
        },
        xxl: {
            required: false,
            default: false
        },
        sheet: {
            required: false,
            default: false
        }
    },
    mounted() {
        if (this.$refs.modal) {
            this.$refs.modal.style.opacity = 1;
        }
    },
    methods: {
        ...mapMutations('modal', ['closeModal']),
        ...mapMutations('sheet', ['closeSheet']),
        doClose () {
            if (this.sheet) {
                this.closeSheet();
            } else {
                this.closeModal();
            }
        }
    },
    computed: {
        isWindows() {
            return navigator.platform.indexOf('Win') > -1;
        }
    }
};
